import { Component, Input, OnInit } from '@angular/core';
import { ReusableGridComponent } from '../../../components/library/reusable-grid/reusable-grid.component';
import { ActionIDs } from '../../../shared/enums/tables.enum';
import { HttpService } from '../../../http.service';

@Component({
  standalone: true,
  imports: [ReusableGridComponent],
  selector: 'app-document-grid',
  templateUrl: './document-grid.component.html',
  styleUrl: './document-grid.component.scss'
})
export class DocumentGridComponent implements OnInit {
  public ActionIDs = ActionIDs;

  @Input()
  merchantId: number = 0;

  data = [
  ];

  merchantDocuments: any[] = [];

  columns = [
    { dataField: 'documentService.documentType.Name', caption: 'Document', dataType: 'string', hidingPriority: 7, validationRules: [{ type: 'required' }] },
    { dataField: 'created', caption: 'Uploaded', dataType: 'date', hidingPriority: 6, validationRules: [{ type: 'required' }] },
    { dataField: 'vetted', caption: 'Vetted', dataType: 'number', hidingPriority: 5, validationRules: [{ type: 'required' }] },
    { dataField: 'expiryDate', caption: 'Valid until', dataType: 'date', hidingPriority: 4, validationRules: [{ type: 'required' }] },
  ];

  constructor(private httpService: HttpService) {
  }

  ngOnInit() {
    this.httpService.getMerchantDocuments(this.merchantId).subscribe(res => {
      this.merchantDocuments = res;
      console.log('mc: ', this.merchantDocuments);
    });
  }

  navigateToDetails(event: any) {
    console.log('Navigating to details for:', event.data);
    // Add your navigation logic here
    // Example: this.router.navigate(['/details', event.data.id]);
  }

  toggleUseNavigation() {
    console.log('Toggling use navigation');
    // Add your logic here to toggle navigation or some related functionality
  }

  handleActionClick(actionData: { action: string, data: any }) {
    const { action, data } = actionData;
    console.log(`Action: ${action}, Data:`, data);
    if (action === 'Edit') {
      this.editTask(data);
    } else if (action === 'Delete') {
      this.deleteTask(data);
    }
  }

  editTask(task: any) {
    console.log('Editing task:', task);
    // Implement your edit logic here
  }

  deleteTask(task: any) {
    console.log('Deleting task:', task);
    // Implement your delete logic here
  }

  addOrder() {

  }
}
